<template>
    <div class="row g-0 login-container">
        <!-- Left Side (Form) -->
        <div class="col-lg-6 d-flex flex-column justify-content-center p-5 position-relative bg-white z-2">
            <div class="w-100 mx-auto" style="max-width: 450px;">
                <a href="/customer/forgot-password"
                    class="text-decoration-none text-brown small mb-4 d-inline-block fw-bold"><i
                        class="bi bi-arrow-left me-2"></i> Back</a>

                <h1 class="text-brown fw-bold font-serif mb-3">OTP Verification</h1>
                <p class="text-muted mb-5 small">Enter the verification code we just sent on your email address.</p>

                <form @submit.prevent="submitVerify">
                    <div class="d-flex gap-3 justify-content-center mb-5">
                        <input v-for="(digit, index) in digits" :key="index"
                               :id="'otp-' + index"
                               type="text" 
                               class="form-control otp-input" 
                               maxlength="1" 
                               v-model="digits[index]"
                               @input="handleInput(index, $event)"
                               @keydown.delete="handleDelete(index, $event)"
                               @paste="handlePaste">
                    </div>

                    <div class="text-center small text-brown fw-bold mb-4">
                        <a href="/customer/login" class="text-brown text-decoration-none">I have an account log in</a>
                    </div>
                    
                    <div class="text-center mb-4">
                        <span v-if="countdown > 0" class="text-muted small">Resend code in {{ countdown }}s</span>
                        <a v-else href="#" @click.prevent="resendOtp" class="text-brown small fw-bold text-decoration-none">Resend Code</a>
                    </div>

                    <button type="submit" class="btn btn-brown w-100 py-2 rounded-2 mb-4" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span v-else>Confirm</span>
                    </button>
                    
                     <div v-if="generalError" class="alert alert-danger mt-3 small">
                        {{ generalError }}
                    </div>
                    <div v-if="successMessage" class="alert alert-success mt-3 small">
                        {{ successMessage }}
                    </div>
                </form>
            </div>

            <div class="position-absolute bottom-0 start-0 w-100 text-muted xx-small text-center pb-4">
                All rights reserved to FIT..... 2025©
            </div>
        </div>

        <!-- Right Side (Visual) -->
        <div
            class="col-lg-6 position-relative d-none d-lg-block split-bg-right d-flex align-items-center justify-content-center overflow-hidden">
            <!-- Angled Divider -->
            <div
                style="position: absolute; top:0; left:0; width: 100%; height: 100%; background-color: transparent; pointer-events: none;">
                <div
                    style="position: absolute; top:0; left: -100px; width: 15vw; height: 100%; background: white; transform: skewX(-15deg); transform-origin: top;">
                </div>
            </div>

            <div class="position-relative text-center z-1 w-75">
                <div class="mb-5">
                    <h1 class="display-3 fw-bold text-brown font-serif">FR<br><span
                            class="h6 fw-normal inter-font letter-spacing-2">FEKRA</span></h1>
                </div>

                <div class="arch-image-container position-relative shadow-lg">
                    <img src="https://placehold.co/400x500/8D6E63/white?text=Living+Room"
                        class="w-100 h-100 object-fit-cover" alt="Interior">
                </div>

                <!-- Decorative +s -->
                <div class="position-absolute top-0 end-0 text-brown small lh-1 opacity-50 pe-4 mt-5">
                    + +<br>+ +<br>+ +
                </div>
                <div class="position-absolute bottom-0 start-0 text-brown small lh-1 opacity-50 ps-4 mb-5">
                    + +<br>+ +<br>+ +
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                digits: ['', '', '', ''],
                loading: false,
                generalError: '',
                successMessage: '',
                countdown: 60,
                timer: null
            }
        },
        mounted() {
            console.log('VerifyOtp Component mounted.');
            this.startTimer();
        },
        computed: {
            otpCode() {
                return this.digits.join('');
            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
             handleInput(index, event) {
                const value = event.target.value;
                
                // Allow only numbers
                if (!/^\d*$/.test(value)) {
                    this.digits[index] = '';
                    return;
                }

                if (value.length === 1 && index < 3) {
                    this.$nextTick(() => {
                        const nextInput = document.getElementById(`otp-${index + 1}`);
                        if (nextInput) nextInput.focus();
                    });
                }
            },
            handleDelete(index, event) {
                if (this.digits[index] === '' && index > 0) {
                     this.$nextTick(() => {
                        const prevInput = document.getElementById(`otp-${index - 1}`);
                        if (prevInput) prevInput.focus();
                    });
                }
            },
             handlePaste(event) {
                event.preventDefault();
                const pastedData = event.clipboardData.getData('text').slice(0, 4);
                if (/^\d+$/.test(pastedData)) {
                    for (let i = 0; i < pastedData.length; i++) {
                        this.digits[i] = pastedData[i];
                    }
                    if (pastedData.length === 4) {
                         document.getElementById('otp-3').focus();
                    }
                }
            },
            startTimer() {
                this.countdown = 60;
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    if (this.countdown > 0) {
                        this.countdown--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            },
            resendOtp() {
                this.loading = true;
                this.generalError = '';
                this.successMessage = '';
                
                axios.post('/customer/resend-otp')
                    .then(response => {
                        this.loading = false;
                        this.successMessage = response.data.message || 'Verification code sent.';
                        this.startTimer();
                    })
                    .catch(error => {
                        this.loading = false;
                        this.generalError = error.response.data.message || 'Error sending code.';
                    });
            },
            submitVerify() {
                this.loading = true;
                this.generalError = '';
                this.successMessage = '';

                if (this.otpCode.length !== 4) {
                    this.generalError = 'Please enter a valid 4-digit code.';
                    this.loading = false;
                    return;
                }

                // Check URL params for context
                const urlParams = new URLSearchParams(window.location.search);
                const context = urlParams.get('context');
                const email = urlParams.get('email');

                let endpoint = '/customer/verify-otp-submit';
                let payload = { code: this.otpCode };

                if (context === 'reset_password') {
                    endpoint = '/customer/verify-reset-code';
                    payload.email = email;
                }

                axios.post(endpoint, payload)
                .then(response => {
                    // Redirect logic
                     window.location.href = response.data.redirect || '/';
                })
                .catch(error => {
                    this.loading = false;
                    this.generalError = error.response.data.message || 'Invalid or expired code.';
                });
            }
        }
    }
</script>

<style scoped>
    .split-bg-right {
        background-image: url('https://placehold.co/1920x1080/F9F5F0/F9F5F0?text=Wood+Texture');
        background-size: cover;
        background-position: center;
        position: relative;
    }

    .login-container {
        min-height: 100vh;
        overflow: hidden;
    }

    .arch-image-container {
        border-top-left-radius: 50% 20%;
        border-top-right-radius: 50% 20%;
        overflow: hidden;
        height: 400px;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    .otp-input {
        width: 60px;
        height: 60px;
        text-align: center;
        font-size: 1.5rem;
        font-weight: bold;
        border: 1px solid #8D6E63;
        border-radius: 8px;
        color: #333;
    }
    
    .otp-input:focus {
        border-color: #8D6E63;
        box-shadow: 0 0 0 0.25rem rgba(141, 110, 99, 0.25);
    }
</style>
